module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7LEjP"))).then(() => parcelRequire('ljYL6'));